import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./perfectattendance.component.html",
})
export class PerfectAttendanceComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		HomeroomID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		GroupID: 0,
		showDetail: "Yes",
		WithCuts: "Yes",
		WithTardies: "Yes",
		SortBy: "Name",
		startDate: new Date(),
		endDate: new Date(),
		ImageLogo: "",
	};
	schoolList: any = [];
	homeroomList: any = [];
	gradeList: any = [];
	academyList: any = [];
	groupList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstShowDetail = [
		{
			ShowDetailDesc: "Yes",
		},
		{
			ShowDetailDesc: "No",
		},
	];
	lstWithCuts = [
		{
			WithCutsDesc: "Yes",
		},
		{
			WithCutsDesc: "No",
		},
	];

	lstWithTardies = [
		{
			WithTardiesDesc: "Yes",
		},
		{
			WithTardiesDesc: "No",
		},
	];
	lstSortBy = [
		{
			SortByDesc: "Name",
		},
		{
			SortByDesc: "Academy",
		},
		{
			SortByDesc: "Homeroom",
		},
		{
			SortByDesc: "Grade",
		},
	];

	ReportID: number = 24;

	subscription: any;

	ngOnInit() {
		// this.loadSchoolist();
		// this.HomeroomList();
		// this.AcademyList();
		// this.GradeList();
		// this.GroupList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(24);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.HomeroomList();
		this.AcademyList();
		this.GradeList();
		this.GroupList();
		this.loadLogolist();
	}

	private HomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.reportService.HomeroomGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.homeroomList = response;

				if (this.homeroomList.length >= 0) {
					this.homeroomList.unshift({
						HomeroomID: 0,
						HomeroomDesc: "All Homerooms",
					});
				} else {
					this.report.HomeroomID = this.homeroomList[0].HomeroomID;
				}
			},
			(error) => {}
		);
	}

	private AcademyList() {
		this.report.AcademyID = 0;
		var result = this.reportService.AcademyGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.academyList = response;

				if (this.academyList.length >= 0) {
					this.academyList.unshift({
						AcademyID: 0,
						AcademyDesc: "All Academies",
					});
				} else {
					this.report.AcademyID = this.academyList[0].AcademyID;
				}
			},
			(error) => {}
		);
	}

	private GradeList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.gradeList = response;

				if (this.gradeList.length >= 0) {
					this.gradeList.unshift({
						GradeLevelID: 0,
						GradeLevelDesc: "All Grades",
					});
				} else {
					this.report.GradeLevelID = this.gradeList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private GroupList() {
		this.report.GroupID = 0;

		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.groupList = response;

				if (this.groupList.length >= 0) {
					this.groupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
				} else if (this.groupList.length == 1) {
					this.report.GroupID = this.groupList[0].GroupID;
				} else {
					this.groupList.push({
						GroupID: 0,
						GroupName: "No Record found",
					});
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// if (!this.report.SchoolID) {
		//     this.errorMessage = "Select the School";
		//     return
		// }

		// if (!this.report.HomeroomID) {
		//     this.errorMessage = "Select the Homeroom";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 24;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		strParam += "|SchoolXML";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.AcademyID + "|AcademyID";
		strParam += "," + this.report.HomeroomID + "|HomeroomID";
		strParam += "," + this.report.GroupID + "|GroupID";
		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.WithCuts + "|WithCuts";
		strParam += "," + this.report.WithTardies + "|WithTardies";
		strParam += "," + this.report.showDetail + "|showDetail";
		strParam += "," + this.report.SortBy + "|ORDERBY";

		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
